// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.part-variant-delete-related__collapse {
  margin: 0;
}
.part-variant-delete-related__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 34px;
  padding: 6px 10px;
  margin: 0;
  border: 1px solid var(--m-border-color, #eaecf0);
  border-radius: 4px;
  background: var(--m-surface-sunken, #f9fafb);
  color: var(--m-text, #344054);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.part-variant-delete-related__toggle svg {
  flex-shrink: 0;
  transition: transform 0.2s ease;
}
.part-variant-delete-related__toggle.is-open {
  color: var(--m-primary, #155eef);
  border-color: var(--m-primary, #155eef);
  background: rgba(21, 94, 239, 0.06);
}
.part-variant-delete-related__toggle.is-open svg {
  transform: rotate(180deg);
}
.part-variant-delete-related__toggle:hover {
  background: var(--m-surface-hover, #f2f4f7);
}
.part-variant-delete-related__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 6px;
  max-height: 156px;
  overflow-y: auto;
  margin-top: 6px;
  padding: 0;
}
.part-variant-delete-related__tile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 3px;
  min-width: 0;
  min-height: 52px;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid var(--m-border-color, #eaecf0);
  background: var(--m-card-background-color, #fff);
  text-align: left;
  overflow: hidden;
  cursor: default;
}
.part-variant-delete-related__tile-code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.25;
  color: var(--m-text, #101828);
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.part-variant-delete-related__tile-name {
  font-size: 0.8125rem;
  line-height: 1.25;
  color: var(--m-text-subtle, #667085);
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

[m-data-theme=dark] .part-variant-delete-related__toggle {
  background: rgba(255, 255, 255, 0.04);
  border-color: var(--m-border-color);
  color: var(--m-text-light);
}
[m-data-theme=dark] .part-variant-delete-related__toggle.is-open {
  background: rgba(21, 94, 239, 0.12);
}
[m-data-theme=dark] .part-variant-delete-related__toggle:hover {
  background: rgba(255, 255, 255, 0.08);
}
[m-data-theme=dark] .part-variant-delete-related__tile {
  background: rgba(255, 255, 255, 0.04);
  border-color: var(--m-border-color);
}
[m-data-theme=dark] .part-variant-delete-related__tile-code {
  color: var(--m-text);
}`, "",{"version":3,"sources":["webpack://./src/views/pages/PartVariants/PartVariants.scss"],"names":[],"mappings":"AACE;EACE,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,gDAAA;EACA,kBAAA;EACA,4CAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,4EAAA;AADJ;AAGI;EACE,cAAA;EACA,+BAAA;AADN;AAII;EACE,gCAAA;EACA,uCAAA;EACA,mCAAA;AAFN;AAIM;EACE,yBAAA;AAFR;AAMI;EACE,2CAAA;AAJN;AAQE;EACE,aAAA;EACA,4DAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;EACA,gDAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAPJ;AAUE;EACE,6EAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AARJ;AAWE;EACE,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATJ;;AAcE;EACE,qCAAA;EACA,mCAAA;EACA,0BAAA;AAXJ;AAaI;EACE,mCAAA;AAXN;AAcI;EACE,qCAAA;AAZN;AAgBE;EACE,qCAAA;EACA,mCAAA;AAdJ;AAiBE;EACE,oBAAA;AAfJ","sourcesContent":[".part-variant-delete-related {\n  &__collapse {\n    margin: 0;\n  }\n\n  &__toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    min-height: 34px;\n    padding: 6px 10px;\n    margin: 0;\n    border: 1px solid var(--m-border-color, #eaecf0);\n    border-radius: 4px;\n    background: var(--m-surface-sunken, #f9fafb);\n    color: var(--m-text, #344054);\n    font-size: 0.875rem;\n    font-weight: 500;\n    line-height: 1.25;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n\n    svg {\n      flex-shrink: 0;\n      transition: transform 0.2s ease;\n    }\n\n    &.is-open {\n      color: var(--m-primary, #155eef);\n      border-color: var(--m-primary, #155eef);\n      background: rgba(21, 94, 239, 0.06);\n\n      svg {\n        transform: rotate(180deg);\n      }\n    }\n\n    &:hover {\n      background: var(--m-surface-hover, #f2f4f7);\n    }\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 6px;\n    max-height: 156px;\n    overflow-y: auto;\n    margin-top: 6px;\n    padding: 0;\n  }\n\n  &__tile {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 3px;\n    min-width: 0;\n    min-height: 52px;\n    padding: 6px 8px;\n    border-radius: 4px;\n    border: 1px solid var(--m-border-color, #eaecf0);\n    background: var(--m-card-background-color, #fff);\n    text-align: left;\n    overflow: hidden;\n    cursor: default;\n  }\n\n  &__tile-code {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    line-height: 1.25;\n    color: var(--m-text, #101828);\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__tile-name {\n    font-size: 0.8125rem;\n    line-height: 1.25;\n    color: var(--m-text-subtle, #667085);\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n[m-data-theme=\"dark\"] .part-variant-delete-related {\n  &__toggle {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: var(--m-border-color);\n    color: var(--m-text-light);\n\n    &.is-open {\n      background: rgba(21, 94, 239, 0.12);\n    }\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.08);\n    }\n  }\n\n  &__tile {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: var(--m-border-color);\n  }\n\n  &__tile-code {\n    color: var(--m-text);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
